// extracted by mini-css-extract-plugin
export var contrastLow = "_3r-1";
export var externalLink = "_3r-2";
export var externalLinkIcon = "_3r-3";
export var link = "_3r-0";
export var linkLabel = "_3r-4";